/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// tanstack query
import { useMutation } from '@tanstack/react-query';

// api
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';

// mantine
import { notifications } from '@mantine/notifications';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { TApiResponseRemoveProductions } from '../types';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const remove = (
	id: string
): Promise<{
	user: TApiResponseRemoveProductions;
}> => {
	return apiClient.delete(`/productions/${id} `);
};

export const useRemove = (page: number, size: number) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'productions.notifications.productionSuccessfullyDeleted'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: [
					'productions',
					{ page: page, size: size },
				],
			});
		},
		onError: (error: { type: string }) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
